import { LuCompass } from 'react-icons/lu'
import { Link } from 'react-router'
import { buttonClass } from '../components/ui/Button.tsx'
import { EmptyState } from '../components/ui/EmptyState.tsx'

export function NotFoundPage() {
  return (
    <EmptyState
      icon={LuCompass}
      color="violet"
      title="Page not found"
      action={
        <Link to="/" className={buttonClass('primary')}>
          Go home
        </Link>
      }
    >
      The page you are looking for does not exist or has moved.
    </EmptyState>
  )
}
